import React from 'react';
import { SvgSearch } from '@edenredespana/oreneta';
import { DROPDOWN_STYLES } from '../constants/masterStyles';

interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

export const MasterSearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder,
}) => (
  <>
    <style>{`
      .search-input-field {
        width: 100%;
        height: 100%;
        padding: 12px 48px 12px 16px;
        font-size: 16px;
        border: 1.5px solid #E0E6ED;
        border-radius: 8px;
        outline: none;
        box-sizing: border-box;
        font-family: Ubuntu;
        color: #23272f;
        transition: border-color 0.2s ease;
      }
      .search-input-field:focus {
        border-color: #0066cc;
      }
      .search-input-field:hover:not(:focus) {
        border-color: #94a3b8;
      }
    `}</style>
    <div style={DROPDOWN_STYLES.searchInputContainer}>
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="search-input-field"
      />
      <span style={DROPDOWN_STYLES.searchInputIconWrapper}>
        <SvgSearch />
      </span>
    </div>
  </>
);
